import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const SettingsContext = createContext(null);

export const SettingsProvider = ({ children }) => {
    const [settings, setSettings] = useState(null);
    const [pages, setPages] = useState({});
    const [stats, setStats] = useState({});

    const load = async () => {
        try {
            const [settingsRes, pagesRes] = await Promise.all([
                api.get("/settings"),
                api.get("/config/pages"),
            ]);
            setSettings(settingsRes.data);
            setPages(pagesRes.data?.pages || {});
            setStats(pagesRes.data?.stats || {});
        } catch (e) {
            console.error("settings/pages load failed", e);
        }
    };

    useEffect(() => { load(); }, []);

    return (
        <SettingsContext.Provider value={{ settings, pages: pages || {}, stats: stats || {}, reload: load }}>
            {children}
        </SettingsContext.Provider>
    );
};

export const useSettings = () => {
    const ctx = useContext(SettingsContext);
    if (!ctx) return { settings: null, pages: {}, stats: {}, reload: async () => {} };
    return {
        ...ctx,
        pages: ctx.pages || {},
        stats: ctx.stats || {},
    };
};

/** Per-page CMS copy with string fallbacks. */
export const usePageCopy = (prefix, fallbacks = {}) => {
    const ctx = useContext(SettingsContext);
    const p = ctx?.pages || {};
    return {
        eyebrow: p[`${prefix}_eyebrow`] ?? fallbacks.eyebrow ?? "",
        title: p[`${prefix}_title`] ?? fallbacks.title ?? "",
        subtitle: p[`${prefix}_subtitle`] ?? fallbacks.subtitle ?? "",
        ctaLabel: p[`${prefix}_cta_label`] ?? fallbacks.ctaLabel ?? "",
    };
};

export const useSiteStats = () => {
    const ctx = useContext(SettingsContext);
    return ctx?.stats || {};
};
